/**
 * Turkish copy — the source of truth for translation keys. Other locales must
 * provide exactly the same keys and `{{placeholders}}` (enforced by tests).
 */
const tr = {
  meta: {
    tagline: 'Videonu paylaşmaya hazırla',
    /** Arama sonucu başlığı: önce aranan şey, en sonda ad (50–60 karakter). */
    title: 'Videoda yüz bulanıklaştır, boşluk kes, altyazı ekle | {{name}}',
    needsJs: 'Shycut tarayıcında çalışır ve JavaScript gerektirir. Videonu düzenlemek için JavaScript’i aç.',
    otherLanguage: 'English',
    notFound: 'Bu sayfa yok.',
    backHome: 'Video aracına git',
    description:
      'Ücretsiz ve gizli video aracı: yüzleri ve plakaları bulanıklaştır, sessizlikleri kes, altyazı ekle, Reels, TikTok ve Shorts için boyutlandır. Hepsi tarayıcında.',
  },
  common: {
    cancel: 'Vazgeç',
    close: 'Kapat',
    retry: 'Tekrar dene',
    done: 'Tamam',
    on: 'Açık',
    off: 'Kapalı',
    seconds: '{{value}} sn',
    of: '{{current}} / {{total}}',
    downloadFailed: 'Uygulamanın bir parçası indirilemedi. Bağlantını kontrol edip tekrar dene.',
  },
  nav: {
    language: 'Dil',
    theme: 'Tema',
    themeLight: 'Açık tema',
    themeDark: 'Koyu tema',
    themeSystem: 'Sistem teması',
    moreProjects: 'Diğer projelerimiz',
    install: 'Uygulamayı yükle',
    home: '{{name}} ana sayfası',
  },
  update: {
    ready: 'Yeni sürüm hazır.',
    apply: 'Güncelle',
    later: 'Sonra',
    version: 'Sürüm {{build}}',
    check: 'Güncellemeyi denetle',
    checking: 'Denetleniyor…',
    current: 'Güncel',
    offline: 'Çevrimdışı',
    updated: 'Shycut güncellendi',
  },
  home: {
    /** Sayfanın H1'i: arayan kişinin kullandığı kelimeler (görsel başlık `title`). */
    heading: 'Tarayıcında çalışan ücretsiz ve gizli video düzenleyici',
    title: 'Bugün ne hazırlıyorsun?',
    subtitle: 'Videonun ne için olduğunu seç. Yüzleri ve plakaları gizle, boşlukları kes, formatı ayarla; hepsi cihazında. Hiçbir şey yüklenmez.',
    choose: 'Dosya seç',
    dropHere: 'Videonu buraya bırak',
    dropActive: 'Bırak, gerisini biz halledelim',
    dropHint: 'MP4, MOV, WebM veya MKV. Birden fazla video seçersen uç uca birleştirebilirsin.',
    dropTrust: '{{size}} yüklendi. Videon burada kalır.',
    convert: {
      display: 'Videonu yüklemeden dönüştür',
      subtitle: 'İşi tarayıcın, kendi cihazında yapar. Videon hiçbir yere gönderilmez: kayıt yok, filigran yok.',
      title: '{{format}} olarak dönüştür',
      body: 'Bir video bırak; bütünüyle, olduğu gibi {{format}} olarak kaydetmeye hazır açılsın. Birden fazla bırakırsan sırayla dönüştürülür.',
      formats: 'Hedef biçim',
      hint: 'MP4, MOV, WebM veya MKV. Birden fazla video seçersen tek tek dönüştürülür.',
      edit: 'Bunun yerine videoyu düzenle',
      compressDisplay: 'Videonu yüklemeden sıkıştır',
      titleLimited: '{{limit}} MB altına sıkıştır',
      bodyLimited: 'Bir video bırak; {{limit}} MB altında {{format}} olarak kaydetmeye hazır açılsın, sığan kaliteyi Shycut seçer. Birden fazla bırakırsan her biri bu sınırın altında kalır.',
      limit: '{{limit}} MB altında',
      dropLimit: 'Boyut sınırını kaldır',
    },
    captions: {
      display: 'Altyazı, kendi cihazında yazılır',
      subtitle: 'Konuşmadan zamanlanmış altyazı ve SRT dosyası, tarayıcında. Hiçbir şey yüklenmez, kayıt da yok.',
      title: '{{language}} altyazı yaz',
      titleTranslate: 'İngilizce altyazı yaz',
      titleTranslateFrom: '{{language}} konuşmayı İngilizce altyazıya çevir',
      body: 'Bir video bırak; Altyazı sekmesinde, ayarlanmış ve yazmaya hazır açılır. Konuşma modeli bir kez iner ve burada çalışır.',
      hint: 'İçinde konuşma olan MP4, MOV, WebM ya da MKV.',
      edit: 'Bunun yerine bir tarif seç',
    },
    captionLink: {
      language: 'Altyazılar {{language}} yazılacak',
      translate: 'Altyazılar İngilizceye çevrilecek',
      translateFrom: 'Altyazı: {{language}} konuşma, İngilizce yazılacak',
      drop: 'Altyazıyı ayarlama',
    },
    fit: {
      display: 'Videonu gideceği yere uydur',
      subtitle: 'Paylaşacağın yerin şekli, süresi ve dosya boyutu, kendi cihazında ayarlanır. Hiçbir şey yüklenmez.',
      title: 'Videoyu {{place}} için uydur',
      body: 'Bir video bırak; {{shape}} olarak yeniden çerçevelenmiş açılır, sen kırparken süresi {{place}} sınırına göre denetlenir.',
      bodyOriginal: 'Bir video bırak; {{place}} kendi şeklini kabul ettiği için olduğu gibi açılır, sen kırparken süresi denetlenir.',
      places: 'Şunun için uydur',
      hint: 'MP4, MOV, WebM ya da MKV. Birden çok video birlikte açılır, birleştirmeye hazır.',
      withRecipe: '“{{recipe}}” tarifiyle: {{promise}}',
      edit: 'Uydurmadan düzenle',
    },
    inspect: {
      display: 'Videon neyi ele veriyor, gör',
      subtitle: 'Telefonlar ve kameralar videonun nerede, ne zaman ve hangi cihazla çekildiğini dosyanın içine yazar. Shycut bunu cihazında okur, hiçbir şey göndermez.',
      title: 'Videonun gizli bilgilerine bak',
      body: 'Taşıdığı yeri, cihazı ve zamanı görmek için bir video bırak; sonra bunlar olmadan temiz bir kopyasını kaydet.',
      hint: 'MP4, MOV, WebM veya MKV. Yalnızca dosyanın bilgileri okunur, görüntüsü asla.',
      reading: 'Dosyanın bilgileri okunuyor…',
      reportsLabel: 'Dosyaların söyledikleri',
      found: 'Bu video {{list}} söylüyor.',
      none: 'Bu videoda nerede, ne zaman ya da hangi cihazla çekildiğine dair bir şey bulunmadı.',
      reveals: {
        location: 'nerede çekildiğini',
        track: 'çekildiği rotayı',
        device: 'hangi cihazla çekildiğini',
        recorded: 'ne zaman kaydedildiğini',
      },
      rows: {
        location: 'Konum',
        track: 'GPS izi',
        device: 'Cihaz',
        recorded: 'Kayıt zamanı',
        software: 'Yazılım',
      },
      inFile: 'Dosyada var',
      notFound: 'Bu dosyada yok',
      position: '{{latitude}}° {{northSouth}}, {{longitude}}° {{eastWest}}',
      hemispheres: { N: 'K', S: 'G', E: 'D', W: 'B' },
      positionNote: 'Yaklaşık bir kilometreye yuvarlanarak gösteriliyor; dosyada tam nokta var.',
      track_one: '{{count}} konum, {{position}} noktasından başlayarak',
      track_other: '{{count}} konum, {{position}} noktasından başlayarak',
      trackNote: 'Kameranın GPS kaydı: rotanın tamamı, saniye saniye.',
      recordedZone: '{{when}} (UTC{{offset}})',
      other_one: '{{count}} bilgi daha',
      other_other: '{{count}} bilgi daha',
      clean: '{{format}} olarak temiz kopya kaydet',
      cleanNote: 'Kopya yalnızca görüntü ve sesten yeniden yazılır; bu bilgilerin hiçbiri gelmez.',
      another: 'Başka bir videoya bak',
      edit: 'Bunun yerine videoyu düzenle',
    },
    intentsLabel: 'Video ne için?',
    record: {
      title: 'Ekranını ve kendini kaydet',
      tagline: 'Ekran, kamera ve mikrofon; bu cihazda.',
      cta: 'Kayıt al',
      promise: 'Sonra duraklamalar kırpılır, sesin temizlenir. Kameran taşınabilen ayrı bir katman olarak kalır.',
      close: 'Kaydediciyi kapat',
    },
    intents: {
      recording: {
        tag: 'Eğitim · Demo · Sunum',
        title: 'Bir ekran kaydı',
        promise: 'Ekranın ve sen; duraklamalar kırpılır, ses temizlenir.',
        detail: 'Kameran sonradan taşınabilen ayrı bir katman olarak kalır. Kayıt bu cihazda yapılır.',
      },
      reels: {
        tag: 'Reels · TikTok · Shorts',
        title: 'Dikey bir klip',
        promise: 'Yüzünü takip eden 9:16, kesilmiş boşluklar, hazır altyazı.',
        detail: 'Yüzler ve plakalar gizlenir. Altyazı için model bir kez indirilir.',
      },
      youtube: {
        tag: 'YouTube',
        title: 'Bir YouTube videosu',
        promise: 'Hafif kesimlerle 16:9 ve dengeli ses.',
        detail: 'Telefon görüntüsüne bulanık arka plan eklenir. Yüksek kalite.',
      },
      privacy: {
        tag: 'Gizlilik',
        title: 'Yüzleri ve plakaları gizle',
        promise: 'Hassas tarama. Başka hiçbir şey değişmez.',
        detail: 'Yüzler ve plakalar bulunur, hareket ettikçe takip edilir.',
      },
      motovlog: {
        tag: 'Sürüş görüntüsü',
        title: 'Bir motovlog',
        promise: 'Rüzgâr sesi alınır, plakalar ve yayalar gizlenir.',
        detail: 'Kask ve göğüs kameraları için. GoPro’nun GPS’i hız göstergesine dönüşür.',
      },
      faces: {
        tag: 'Gizlilik',
        title: 'Yüzleri gizle',
        promise: 'Her yüz bulunur ve hareket ettikçe takip edilerek bulanıklaşır.',
        detail: 'Video açılır açılmaz başlar. Bir kerelik ~4\u00a0MB indirme.',
      },
      plates: {
        tag: 'Gizlilik',
        title: 'Plakaları gizle',
        promise: 'Plakalar bulunur ve kare kare bulanıklaşır.',
        detail: 'Video açılır açılmaz başlar. Bir kerelik 8–15\u00a0MB indirme.',
      },
      fillers: {
        tag: 'Ses',
        title: 'Iıı, eee seslerini kes',
        promise: 'Duraksamalar çıkar. Söylemek istediğin her kelime kalır.',
        detail: 'Sesin kendisinde, kendi cihazında bulunur. İndirme yok.',
      },
      captions: {
        tag: 'Altyazı',
        title: 'Altyazı ekle',
        promise: 'Kelime kelime zamanlanmış altyazı, kendi cihazında yazılır.',
        detail: 'Kendiliğinden başlar. Konuşma modeli (100–300\u00a0MB) bir kez iner; mobil veride seni bekler.',
      },
      blank: {
        tag: 'Her şey',
        title: 'Sadece bir video',
        promise: 'Olduğu gibi açılır: sen seçene kadar hiçbir şey taranmaz ya da kesilmez.',
        detail: 'Her araç bir dokunuş uzağında: yüzler, kesim, altyazı, boyut.',
      },
      silence: {
        tag: 'Ses',
        title: 'Duraksamaları ve ııı’ları kes',
        promise: 'Boşluklar ve tereddütler çıkar. Her kelime kalır.',
        detail: 'Sesin kendisinde, kendi cihazında bulunur. İndirme yok.',
      },
      subtitles: {
        tag: 'Altyazı',
        title: 'Altyazı dosyası oluştur',
        promise: 'Konuşma zamanlı satırlar olarak yazılır, SRT dosyası olarak kaydedilir.',
        detail: 'Görüntüye basılmaz; YouTube ya da herhangi bir oynatıcı için. Konuşma modeli (100–300\u00a0MB) bir kez iner; mobil veride seni bekler.',
      },
    },
    jobsLabel: 'Ya da tek bir iş',
    mine: 'Tariflerin',
    thumbAlt: 'Örnek sonuç: {{title}}',
    proofTitle: 'Tasarımı gereği gizli',
    proof: {
      device: { title: 'Cihazında çalışır', body: 'Videoyu tarayıcın çözer, inceler ve yeniden kodlar. Gönderilecek bir sunucu yok.' },
      ledger: { title: 'Hiçbir şey yüklenmez', body: 'Üst kısımdaki sayaç bu sayfanın gönderdiği her baytı ölçer. Sıfırda kalır.' },
      location: { title: 'Konum bilgisi silinir', body: 'Telefonlar videolara GPS konumu gizler. Dışa aktarılan dosya bunu taşımaz.' },
    },
    privacyNote: 'Ücretsiz, kayıt yok, filigran yok.',
    faq: {
      title: 'Sorular',
      items: {
        upload: {
          q: 'Videom bir yere yükleniyor mu?',
          a: 'Hayır. Tarayıcın videoyu kendi cihazında açar, düzenler ve kaydeder. Tek indirme yapay zekâ modelleridir, o da bir kez; üstteki sayaç hiçbir şeyin yüklenmediğini gösterir.',
        },
        faces: {
          q: 'Videoda yüzleri nasıl bulanıklaştırırım?',
          a: 'Videoyu aç, Gizlilik sekmesinde yüzlerin yanındaki “Ara”ya dokun. Yüzler bulunur, hareket ettikçe takip edilir ve bulanıklık, piksel, emoji ya da kutuyla gizlenir. Görünmesini istediğin kişiye (örneğin kendine) dokun.',
        },
        plates: {
          q: 'Plakaları ve başka şeyleri de gizler mi?',
          a: 'Evet. Plakaları tek dokunuşla arat ya da başka bir şeyin (kapı numarası, logo, ekran) etrafını çiz; hareket ettikçe takip edilir.',
        },
        cuts: {
          q: 'Sessizlikleri ve “ııı, eee”leri keser mi?',
          a: 'Evet. Kesmeyi açınca duraksamalar ve uzatılan “ııı”, “eee”, “hmm” sesleri bulunup kesilir. İstediğin kısmı elle de çıkarabilir, Metin sekmesinde kelimeleri silerek de kesebilirsin.',
        },
        captions: {
          q: 'Altyazı hangi dillerde çalışır?',
          a: 'Konuşma cihazında altyazıya dönüşür: Türkçe, İngilizce, Almanca, Fransızca, İspanyolca ve daha fazlası. Dil otomatik bulunur, istersen kendin seçersin.',
        },
        phone: {
          q: 'Telefonda çalışır mı?',
          a: 'Evet, güncel Chrome veya Safari’de; uygulama gibi de kurabilirsin. Uzun videolar bilgisayarda daha hızlı işlenir.',
        },
        free: {
          q: 'Gerçekten ücretsiz mi?',
          a: 'Evet: kayıt yok, filigran yok, sınır yok. Her şey cihazında çalıştığı için ödenecek bir sunucu da yok.',
        },
      },
    },
    footer: 'Gizlilik odaklı, açık web teknolojileriyle yapıldı.',
    blog: {
      title: 'Blogdan',
      lead: 'Videolarını gizliliğinden ödün vermeden paylaşman için rehberler ve ipuçları.',
      all: 'Tüm yazılar',
      fallback: 'Yazılar şimdilik {{language}}.',
      loading: 'Yazılar yükleniyor',
    },
  },
  /** İçerik sayfalarına bağlantılar (src/config/site-pages.ts); derleme aynı adları sayfalarda da kullanır. */
  site: {
    toolsTitle: 'Ücretsiz araçlar',
    compareTitle: 'Karşılaştır',
    blog: 'Blog',
    links: {
      faces: 'Videoda yüz bulanıklaştırma',
      pixelate: 'Videoda yüz pikselleştirme',
      moving: 'Hareketli yüz bulanıklaştırma',
      kids: 'Çocuk yüzü bulanıklaştırma',
      plates: 'Plaka bulanıklaştırma',
      dashcam: 'Araç kamerası video düzenleme',
      location: 'Konum bilgisini silme',
      metadata: 'Video EXIF bilgileri',
      findlocation: 'Videodan konum bulma',
      silence: 'Sessizlikleri kesme',
      captions: 'Videoya altyazı ekleme',
      srt: 'SRT altyazı oluşturma',
      resize: 'Videoyu dikey yapma',
      merge: 'Video birleştirme',
      mixed: 'Dikey ve yatay video birleştirme',
      music: 'Videoya müzik ekleme',
      speedup: 'Video hızlandırma',
      screen: 'Ekran kaydedici',
      motovlog: 'Motovlog düzenleme',
      gopro: 'GoPro videolarını birleştirme',
      speed: 'GoPro hız göstergesi',
      wind: 'Rüzgâr sesini giderme',
      capcut: 'CapCut alternatifi',
      veed: 'VEED alternatifi',
      kapwing: 'Kapwing alternatifi',
      blurme: 'BlurMe alternatifi',
      descript: 'Descript alternatifi',
      clipchamp: 'Clipchamp alternatifi',
      flexclip: 'FlexClip alternatifi',
      inshot: 'InShot alternatifi',
      clideo: 'Clideo alternatifi',
      loom: 'Loom alternatifi',
      obs: 'OBS alternatifi',
      screenpal: 'ScreenPal alternatifi',
      handbrake: 'HandBrake alternatifi',
      cloudconvert: 'CloudConvert alternatifi',
      freeconvert: 'FreeConvert alternatifi',
      privacy: 'Gizlilik politikası',
    },
    /** Hubs of the programmatic pages (HUB_PAGES in src/config/site-pages.ts). */
    hubs: {
      convert: 'Video dönüştürücü',
      compress: 'Video sıkıştırma',
      specs: 'Video boyutları',
      jobs: 'Platform rehberleri',
      filesize: 'Video dosya boyutu',
    },
  },
  load: {
    reading: 'Video okunuyor…',
    joining: 'Kamera bölümleri birleştiriliyor… %{{percent}}',
    errors: {
      unsupportedFormat: 'Bu dosya biçimi desteklenmiyor. MP4, MOV, WebM veya MKV dene.',
      noVideo: 'Bu dosyada video bulunamadı.',
      noAudio: 'Bu dosyada çalınabilir bir ses bulunamadı.',
      codecUnsupported: 'Bu videonun kodlaması ({{codec}}) tarayıcında açılamıyor. Chrome veya Edge ile dene ya da videoyu MP4 (H.264) olarak kaydet.',
      browserUnsupported: 'Tarayıcın video işlemeyi desteklemiyor. Chrome, Edge veya Safari’nin güncel sürümünü kullan.',
      unknown: 'Video açılamadı: {{message}}',
      sourceUnreadable: 'Videoya artık ulaşılamıyor. Açtıktan sonra değişmiş ya da taşınmış olabilir; videoyu yeniden aç.',
    },
  },
  ledger: {
    chip: '{{size}} yüklendi',
    title: 'Gizlilik kaydı',
    uploaded: 'Yüklenen',
    downloaded: 'Bu ziyarette indirilen',
    thisSite: 'Bu site',
    nothingYet: 'Henüz bir şey indirilmedi.',
    explain: 'Videon ve sesin bu cihazdan hiç çıkmaz. Bu site yalnızca kendisine, yapay zekâ modelleri için Hugging Face’e ve izin verdiysen ziyaretleri saymak için Google Analytics’e bağlanır. Dosyalarını asla göndermez.',
    analytics: 'Ziyaret istatistikleri (Google Analytics)',
    analyticsNote: 'Hangi sayfaların ziyaret edildiği; dosyaların asla. Yükleme sayılmaz.',
    verify: 'Kendin doğrula: tarayıcının geliştirici araçlarında Ağ sekmesini izle ya da modeller indikten sonra uçak moduna geç.',
    unexpected: 'Bir yükleme algılandı. Lütfen bildir; bu asla olmamalı.',
  },
  editor: {
    newVideo: 'Yeni video',
    leaveTitle: 'Bu videodan çıkılsın mı?',
    leaveBody: 'Düzenlemelerin, tarama sonuçları ve altyazılar silinecek. Bu geri alınamaz.',
    leaveRecordingBody: 'Bu kayıt henüz dışa aktarılmadı. Çıkarsan bu cihazdan silinir.',
    leaveConfirm: 'Çık',
    undo: 'Geri al',
    redo: 'Yinele',
    tools: 'Araçlar',
    export: 'Dışa aktar',
    tabs: {
      camera: 'Kamera',
      privacy: 'Gizlilik',
      cut: 'Kes',
      text: 'Metin',
      format: 'Boyut',
      audio: 'Ses',
      captions: 'Altyazı',
      telemetry: 'Sürüş',
      media: 'Medya',
    },
    previewUnsupported: 'Bu video tarayıcında önizlenemiyor, ama dışa aktarma çalışır.',
    locationFound: 'Videoda konum bilgisi var — dışa aktarırken silinecek.',
    clips_one: '{{count}} klip',
    clips_other: '{{count}} klip',
    shortcuts: 'Boşluk: oynat/durdur · ←/→: 1 sn ileri/geri · X: elle kes',
  },
  player: {
    play: 'Oynat',
    timeline: 'Zaman çizelgesi',
    pause: 'Durdur',
    editedPreview: 'Sonuç',
    originalPreview: 'Orijinal',
    outputDuration: 'Yeni süre {{duration}}',
    space: 'Boşluk',
    modeTooltip: 'Sonuç: kesimler ve eklediklerinle, dışa aktarılacağı gibi. Orijinal: videonun dokunulmamış hali.',
    lengthTooltip: 'Çıkarılan ve hızlandırılan kısımlardan sonra videonun uzunluğu, ve ne kadar kısaldığı.',
    saved: '−{{duration}}',
    safeArea: 'Güvenli alan · TikTok, Reels, Shorts',
    safeAreaFor: 'Güvenli alan · {{place}}',
    safeAreaCovered: 'Uygulamanın butonları burayı kapatır',
  },
  privacy: {
    intro: 'Videodaki yüzleri ve plakaları yapay zekâ ile bulup gizleyelim.',
    layerVideosNotScanned: 'Üste koyduğun videolar taranmıyor; içlerindeki yüzler görünür kalır.',
    kinds: { face: 'Yüzler', plate: 'Plakalar' },
    kindHints: { face: 'Henüz aranmadı', plate: 'Araç görünüyorsa ara' },
    kindSuggested: { face: 'Tek dokunuşla bul ve gizle', plate: 'Tarifin plakaları da gizliyor' },
    kindQueued: 'Sırada…',
    kindFailed: 'Tarama tamamlanamadı',
    kindFound_one: '{{count}} tane bulundu',
    kindFound_other: '{{count}} tane bulundu',
    kindNone: 'Bulunamadı',
    findKind: 'Ara',
    cancelKind: '{{kind}} taramasını durdur',
    rescanKind: '{{kind}} için yeniden tara',
    clearKind: '{{kind}} sonuçlarını kaldır (gizlenmez)',
    precision: 'Tarama',
    precisionFast: 'Hızlı',
    precisionThorough: 'Hassas',
    precisionHint: 'Hassas tarama uzaktaki küçük yüzleri de yakalar ama daha uzun sürer.',
    scopeNote: 'Yalnızca videoda kalan kısımlar taranır. Kestiğin bir kısmı geri getirirsen o da kendiliğinden taranır.',
    modelNote: 'Yapay zekâ cihazında çalışır. Modeller ilk taramada bir kez iner (yüzler için ~{{face}}, plakalar için ~{{plate}} daha) ve bir yıl, ya da yenisi gelene kadar cihazında saklanır.',
    scanning: 'Taranıyor… %{{percent}}',
    scanningRestored: 'Geri getirdiğin kısımlar taranıyor… %{{percent}}',
    loadingModel: 'Yapay zekâ hazırlanıyor…',
    foundNone: 'Gizlenecek bir şey bulunamadı.',
    foundNoneHint: 'Kask veya gözlük yüzü kapatıyorsa “Hassas” taramayı dene.',
    enabled: 'Gizlemeyi uygula',
    style: 'Görünüm',
    styles: { blur: 'Bulanık', pixelate: 'Piksel', emoji: 'Emoji', solid: 'Kutu' },
    strength: 'Yoğunluk',
    padding: 'Kenar payı',
    sticker: {
      add: 'Kendi görselini ekle',
      yours: 'Senin görselin',
      hint: 'Ya da kendi görselini kullan: yüzü kapatacak bir karakter ya da şeffaf arka planlı gözlük, bıyık veya şapka.',
      placement: 'Yerleşim',
      placements: { cover: 'Tüm yüz', eyes: 'Gözler', mouth: 'Ağız', head: 'Baş' },
      coverHint: 'Görselin yüzün tamamını kapatır. Şeffaf kısımlarının altı bulanık kalır.',
      wornHint: 'Yüz yine bulanıklaşır, görselin üstüne oturur. Kameraya dönük yüzlerde en iyi sonucu verir; plakalar ve alanlar tamamen kapanır.',
      change: 'Değiştir',
      remove: 'Kaldır',
      errors: {
        'not-image': 'Bu dosya bir görsel değil. PNG, WebP ya da JPG dene.',
        'too-big': 'Bu görsel çok büyük. 25 MB’tan küçük bir görsel dene.',
        unreadable: 'Bu görsel açılamadı. PNG, WebP ya da JPG dene.',
        empty: 'Bu görsel tamamen şeffaf, gösterilecek bir şey yok.',
      },
    },
    items: 'Bulunanlar',
    itemsHint: 'Gizlemek istemediğine dokun — örneğin kendi yüzün.',
    hideAll: 'Tümünü gizle',
    showAll: 'Tümünü göster',
    notification: 'Bildirim',
    showNotification: 'Bu bildirimi göster',
    notificationsHint: 'Ekranda beliren bildirimler gizlendi. Göstermek istediğini kaldır.',
    kind: { face: 'Yüz', plate: 'Plaka', manual: 'Alan' },
    hidden: 'Gizli',
    visible: 'Görünür',
    toggleItem: '{{kind}} · {{start}}–{{end}}',
    jumpTo: 'Bu ana git',
    addArea: 'Alan ekle',
    addAreaHint: 'Yapay zekânın bulamadığını (kask, logo, ev numarası) kendin seç; hareket ederse takip edilir.',
    drawHint: 'Gizlemek istediğin alanı çiz · Esc ile vazgeç',
    trackingArea: 'Alan takip ediliyor… %{{percent}}',
    removeArea: 'Alanı kaldır',
    errors: {
      failed: 'Tarama tamamlanamadı: {{message}}',
      trackFailed: 'Alan takip edilemedi: {{message}}',
      framesUnreadable: 'Bu tarayıcı videonun karelerini okuyamadı (bazı telefonların HDR videolarında olur). Chrome’un güncel sürümünü dene ya da videoyu kamerada “Yüksek uyumluluk / H.264” ile kaydet.',
    },
  },
  cut: {
    removed: 'Çıkarılan kısımlar',
    removedHint: 'Elle kestiğin kısımlar ve kayıtta attığın çekimler. Fikrini değiştirirsen geri getirebilirsin.',
    manual: 'Bir kısmı çıkar',
    manualHint: 'Aradan bir kısmı çıkar: başladığı yere gelip “Kısım çıkar”a bas, bittiği yere gelip “Buraya kadar çıkar”a bas. Klip bölünmez, yalnızca o kısım çıkar. Kısayol: X.',
    manualMarking: 'Çıkarılacak kısmın bittiği yere git (oynat ya da zaman çizelgesinde kaydır), sonra “Buraya kadar çıkar”a bas. Esc ile vazgeç.',
    manualStart: 'Kısım çıkar',
    manualTooltip: 'Bir kısmı videodan çıkarır: önce başladığı yeri işaretler, sonra bittiği yere gidip tekrar basarsın.',
    manualFinish: 'Buraya kadar çıkar',
    manualFinishTitle: '{{start}} ile burası arasını çıkar',
    removedLength: '{{duration}} uzunluğunda',
    restore: 'Geri getir',
    restoreAll: 'Hepsini geri getir',
    trim: 'Başı ve sonu kırp',
    trimHint: 'Zaman çizelgesindeki tutamaçları sürükle ya da oynatma imlecini kullan.',
    start: 'Başlangıç',
    end: 'Bitiş',
    setStart: 'Başlangıcı buraya al',
    setEnd: 'Bitişi buraya al',
    resetTrim: 'Sıfırla',
    speech: 'Konuşmayı toparla',
    fillers: 'Iıı, eee seslerini kes',
    fillersHint: 'Düşünürken uzattığın sesleri (ııı, eee, hmm) bulup çıkarır. Kelimelere dokunmaz.',
    fillerStats_one: '{{count}} duraksama sesi · {{duration}} kısalır',
    fillerStats_other: '{{count}} duraksama sesi · {{duration}} kısalır',
    noFillers: 'Iıı, eee gibi bir duraksama bulunamadı.',
    fillerListen: 'Orijinalde dinle',
    strictness: 'Ne kadar sıkı kesilsin?',
    silence: 'Sessiz kısımları kes',
    silenceHint: 'Konuşma arasındaki boşlukları otomatik olarak atar.',
    presets: { gentle: 'Hafif', balanced: 'Dengeli', aggressive: 'Sıkı' },
    analyzing: 'Ses inceleniyor…',
    stats_one: '{{count}} sessiz bölüm · {{duration}} kısalacak',
    stats_other: '{{count}} sessiz bölüm · {{duration}} kısalacak',
    noSilence: 'Kesilecek belirgin bir sessizlik yok.',
    everythingRemoved: 'Bu ayarlarla videodan geriye bir şey kalmıyor. Kırpmayı veya kesme ayarını gevşet.',
  },
  placement: {
    names: {
      'instagram-reels': 'Instagram Reels',
      'instagram-story': 'Instagram Hikâye',
      tiktok: 'TikTok',
      'youtube-shorts': 'YouTube Shorts',
      youtube: 'YouTube',
      linkedin: 'LinkedIn',
      x: 'X',
      pinterest: 'Pinterest',
      shopify: 'Shopify ürün videosu',
    },
    short: {
      'instagram-reels': 'Reels',
      'instagram-story': 'Hikâye',
      tiktok: 'TikTok',
      'youtube-shorts': 'Shorts',
      youtube: 'YouTube',
      linkedin: 'LinkedIn',
      x: 'X',
      pinterest: 'Pinterest',
      shopify: 'Shopify',
    },
    units: { h: 'sa', min: 'dk', s: 'sn' },
    asFilmed: 'Çekildiği gibi',
    upTo: 'En fazla {{length}}',
    from: 'En az {{length}}',
    under: '{{size}} altında',
    title: '<name>{{place}}</name> için uyduruldu',
    length: {
      fits: '{{length}} uzunluğundaki bu kurgu, {{place}} sınırları içinde.',
      short: '{{place}} en az {{min}} uzunluğunda video alır; bu kurgu {{length}}. Biraz daha ekle.',
      long: '{{place}} en fazla {{max}} alır; bu kurgu {{length}}. Sığması için {{over}} kırp.',
      verified: '{{max}} üzeri: {{place}} bunu yalnızca doğrulanmış hesaplardan alır.',
      premium: '{{max}} üzeri: {{place}} bunu yalnızca Premium hesaplardan alır.',
    },
    reframe: '{{shape}} oranına dön',
    reframed: 'Çerçeve sonradan değişti; {{place}} {{shape}} ister.',
    stop: 'Uydurmayı bırak',
  },
  format: {
    aspect: 'En-boy oranı',
    aspects: {
      original: { label: 'Orijinal', hint: 'Olduğu gibi' },
      '9:16': { label: '9:16', hint: 'Reels · TikTok · Shorts' },
      '1:1': { label: '1:1', hint: 'Kare gönderi' },
      '4:5': { label: '4:5', hint: 'Instagram gönderi' },
      '16:9': { label: '16:9', hint: 'YouTube · yatay' },
    },
    fit: 'Yerleşim',
    fits: { crop: 'Kırp', blurFill: 'Bulanık arka plan' },
    focus: 'Kadraj',
    focusHint: 'Önizlemede kadrajı sürükleyerek odak noktasını seç.',
    splitNote: 'Bölünmüş düzende ekranın tamamı kameranın yanında durur; kırpılacak bir şey yok.',
    framings: { manual: 'Elle', follow: 'Yüzü takip et' },
    followHint: 'Kadraj ana kişiyi yumuşak hareketlerle takip eder. Görünür bıraktığın yüz önceliklidir.',
    followNeedsScan: 'Takip için önce videodaki yüzleri bulalım.',
    findFaces: 'Yüzleri bul',
    findingFaces: 'Yüzler aranıyor… %{{percent}}',
    noFaces: 'Videoda takip edilecek yüz bulunamadı.',
    resolution: 'Çözünürlük',
    resolutions: { source: 'Orijinal', '1080': '1080p', '720': '720p' },
    outputSize: 'Çıktı {{width}}×{{height}}',
  },
  audio: {
    mute: 'Sesi kapat',
    muteHint: 'Video sessiz dışa aktarılır.',
    normalize: 'Sesi dengele',
    normalizeHint: 'Ses seviyesini sosyal medya standardına (-14 LUFS) getirir.',
    measured: 'Şu an {{lufs}} LUFS',
    lufsExplained: '(LUFS, sesin kulağa ne kadar yüksek geldiğinin ölçüsü.)',
    measuring: 'Ölçülüyor…',
    noAudio: 'Bu videoda ses yok.',
    unsupported: 'Tarayıcın bu videonun sesini ({{codec}}) işleyemiyor; video sessiz dışa aktarılır. Chrome veya Safari’nin güncel sürümüyle dene.',
    denoise: 'Rüzgâr ve gürültü azaltma',
    denoiseHint: 'Konuşmayı korur; rüzgâr, motor ve uğultuyu bastırır. Dışa aktarırken uygulanır.',
    muteKeepsMusic: 'Eklediğin müzik ve sesler yine çalar.',
    music: 'Müzik ve sesler',
    addMusic: 'Müzik ekle',
    musicHint: 'Müzik videonun başından başlar ve biri konuşurken kendiliğinden kısılır. Dosya bu cihazdan çıkmaz.',
  },
  captions: {
    suggested: 'Mobil veride olabilirsin, bu yüzden altyazı seni bekliyor. Konuşma modeli (~{{size}}) bir kez, sen oluşturduğunda iner.',
    intro: 'Konuşmaları otomatik olarak yazıya dökelim. Yapay zekâ cihazında çalışır; ses hiçbir yere gönderilmez.',
    missingClips_one: 'Altyazıdan sonra eklenen {{count}} klibin altyazısı yok.',
    missingClips_other: 'Altyazıdan sonra eklenen {{count}} klibin altyazısı yok.',
    addMissing_one: 'Onun altyazısını ekle',
    addMissing_other: 'Onların altyazısını ekle',
    language: 'Dil',
    languages: {
      auto: 'Otomatik algıla',
      tr: 'Türkçe',
      en: 'English',
      de: 'Deutsch',
      fr: 'Français',
      es: 'Español',
      it: 'Italiano',
      pt: 'Português',
      ru: 'Русский',
      ar: 'العربية',
      nl: 'Nederlands',
    },
    quality: 'Model',
    qualities: { fast: 'Hızlı', accurate: 'Kaliteli' },
    qualityHint: 'Model bir kez indirilir (Hızlı ~{{fast}}, Kaliteli ~{{accurate}}) ve bir yıl, ya da yenisi gelene kadar cihazında saklanır. Türkçe için “Kaliteli” önerilir.',
    generate: 'Altyazı oluştur',
    regenerate: 'Yeniden oluştur',
    downloading: 'Model indiriliyor… %{{percent}}',
    preparing: 'Yapay zekâ hazırlanıyor…',
    downloadSize: '{{loaded}} / {{total}} MB · tek seferlik indirme',
    staysLocal: 'Yalnızca model indirilir. Videon ve sesin cihazından çıkmaz.',
    transcribing: 'Konuşmalar yazıya dökülüyor… %{{percent}}',
    burnIn: 'Altyazıyı videoya ekle',
    burnInHint: 'Sosyal medyada videoların çoğu sessiz izlenir.',
    style: 'Görünüm',
    styles: { pop: 'Vurgulu', classic: 'Klasik', box: 'Kutulu', minimal: 'Sade' },
    position: 'Konum',
    positions: { top: 'Üst', middle: 'Orta', bottom: 'Alt' },
    positionHint: 'Altyazıyı videonun üzerinde sürükleyerek istediğin yere de taşıyabilirsin.',
    positionPlaced: '{{place}} uygulamasının videonun üzerine çizdiklerinden uzağa yerleştirildi. Yine de istediğin yere sürükleyebilirsin.',
    positionDragged: 'Altyazı sürüklediğin yerde duruyor. Hazır bir konum seçersen oraya geçer.',
    resetPosition: 'Sıfırla',
    size: 'Yazı boyutu',
    lines: 'Satırlar',
    linesHint: 'Yanlış duyulan bir kelimeyi düzeltmek için satıra dokun.',
    downloadSrt: 'SRT indir',
    srtExplained: 'SRT, altyazıların ayrı bir dosyası. YouTube, Vimeo veya video oynatıcılara yükleyince izleyici altyazıyı açıp kapatabilir; videoya yazılmaz.',
    languageHint: '“Otomatik” konuşmadan dili bulur. Yanlış bulursa buradan seç.',
    detected: 'Konuşma {{language}} olarak algılandı. Yanlışsa yukarıdan dili seç.',
    writtenIn: 'Altyazılar {{language}} olarak yazıldı.',
    task: 'Altyazıyı yaz',
    tasks: { transcribe: 'Konuşulduğu dilde', translate: 'İngilizce' },
    taskHint: 'İngilizce seçilirse konuşma modeli, konuşulan dil ne olursa olsun dinlerken çevirir. Satırlar konuşmayı izler; tek tek kelimelerin zamanlaması yaklaşıktır.',
    translatedFrom: 'Altyazılar {{language}} konuşmanın İngilizce çevirisi.',
    redo: 'Yeniden yaz',
    fastTranslation: 'Hızlı model, Kaliteli modele göre çok daha zayıf çevirir. İngilizce altyazı için aşağıdan Kaliteli’yi seç.',
    redoTaskHint: 'Altyazılar yukarıda seçildiği gibi yeniden yazılsın mı? Satırlarda yaptığın düzeltmeler gider.',
    redoInLanguage: 'Bu dilde oluştur',
    redoHint: 'Şu anki altyazılar {{language}}. Seçtiğin dilde yeniden oluşturulsun mu? Satırlarda yaptığın düzeltmeler gider.',
    removeLine: 'Satırı sil',
    empty: 'Videoda konuşma bulunamadı.',
    errors: {
      failed: 'Altyazı oluşturulamadı: {{message}}',
    },
  },
  telemetry: {
    enable: 'Sürüş göstergesini ekle',
    enableHint: 'Kameranın GPS’inden gelen hız ve rakım videonun üzerine çizilir.',
    style: 'Görünüm',
    styles: { dial: 'Kadran', minimal: 'Sade' },
    show: 'Göster',
    fields: { speed: 'Hız', altitude: 'Rakım', lean: 'Yatış açısı', gforce: 'G-kuvveti' },
    estimatedHint: 'Yatış ve G-kuvveti GPS’ten hesaplanır; tahmini değerlerdir.',
    nothingShown: 'Göstermek için en az bir değer seç.',
    position: 'Yerleşim',
    corners: { 'top-left': 'Sol üst', 'top-right': 'Sağ üst', 'bottom-left': 'Sol alt', 'bottom-right': 'Sağ alt' },
    size: 'Boyut',
    units: 'Birimler',
    unitSystems: { metric: 'km/h · m', imperial: 'mph · ft' },
    stats: { topSpeed: 'En yüksek hız', distance: 'Mesafe', climb: 'Tırmanış', maxLean: 'En fazla yatış' },
    gaps: 'Videonun yaklaşık %{{percent}} kadarında GPS sinyali yok; gösterge orada çizgi gösterir.',
    privacyNote: 'Yalnızca bu değerler çizilir. Rotan ve koordinatların videoda hiç görünmez, konum bilgisi yine silinir.',
    noFixTitle: 'Bu videoda GPS sinyali yok',
    noFixBody: 'Kamera konum kaydetmemiş. GoPro’da GPS’i aç ve kayda basmadan önce GPS simgesinin sabitlenmesini bekle.',
    noneBody: 'Bu videoda kameradan gelen sürüş verisi yok.',
  },
  zones: {
    title: 'Gizli yerler',
    suggest: 'Sürüşler çoğu zaman evden başlar. Bu sürüşün başladığı ve bittiği yerin {{radius}} çevresi gizlensin mi?',
    suggestAction: 'Başlangıç ve bitişi gizle',
    mapLabel: 'Sürüş rotası; gizlenen kısımlar kesik çizgiyle gösterilir',
    mapHint: 'Rotaya dokun, video o ana gitsin. Harita indirilmez; çizim kameranın GPS’inden.',
    enable: 'Gizli yerleri videodan çıkar',
    enableHint: 'Bu yerlerin çevresinde geçen süre videoda gizlenir, gösterge de kapanır.',
    hideEnds: 'Başlangıç ve bitişi gizle',
    hideEndsHint: 'Sürüşün başladığı ve bittiği yerin {{radius}} çevresi.',
    noPlaces: 'Kayıtlı yer yok. Evinin ya da işinin önünden geçtiğin anda durdur ve aşağıdan ekle.',
    placeName: 'Yer {{number}}',
    onRide: 'Bu sürüşte geçiyor',
    notOnRide: 'Bu sürüşte yok',
    removePlace: 'Yer {{number}} kaldır',
    addHere: 'Burayı gizle',
    addHereHint: 'Videodaki şu anki konum kaydedilir; bu sürüşte ve sonrakilerde gizlenir.',
    noFixHere: 'Bu anda GPS sinyali yok; sinyalin olduğu bir ana git.',
    alreadyPrivate: 'Burası zaten gizli bir yerin içinde.',
    action: 'Ne yapılsın',
    actions: { blur: 'Bulanıklaştır', cut: 'Kes' },
    radius: 'Çap',
    hiddenTimes: 'Gizlenen kısımlar',
    storedLocally: 'Kayıtlı yerler yalnızca bu cihazda durur; hiçbir yere gönderilmez, tariflere ve videolara yazılmaz.',
  },
  presets: {
    title: 'Tarifler',
    hint: 'Tarif; boyut, kesme, ses, gizlilik, altyazı ve sürüş göstergesi ayarlarını saklar. Videoya özel kırpma ve seçimler saklanmaz.',
    builtIn: {
      recording: { name: 'Ekran kaydı', body: 'Hafif kesim, temiz ses, net yazı, ekrandaki yüzler gizli' },
      reels: { name: 'Reels · TikTok', body: '9:16, yüz takibi, sessizlik kesme, altyazı ve gizlilik' },
      youtube: { name: 'YouTube', body: '16:9, bulanık arka plan, hafif kesme, yüksek kalite' },
      motovlog: { name: 'Motovlog', body: 'Rüzgâr azaltma, hassas yüz ve plaka gizleme, hız göstergesi' },
      privacy: { name: 'Sadece gizlilik', body: 'Yüzleri ve plakaları hassas tarayıp gizler' },
      faces: { name: 'Yüzleri gizle', body: 'Yüzleri hassas tarayıp gizler' },
      plates: { name: 'Plakaları gizle', body: 'Plakaları hassas tarayıp gizler' },
      fillers: { name: 'Iıı, eee seslerini kes', body: 'Yalnızca duraksamaları keser' },
      captions: { name: 'Altyazı', body: 'Kelime zamanlı altyazıyı cihazında yazar' },
      blank: { name: 'Boş', body: 'Hiçbir şey uygulanmaz: özgün boyut, kesim yok' },
      silence: { name: 'Duraksamaları ve ııı’ları kes', body: 'Yalnızca boşlukları ve tereddütleri keser' },
      subtitles: { name: 'Altyazı dosyası', body: 'SRT dosyası için altyazı yazar, görüntüye basmaz' },
    },
    mine: 'Tariflerim',
    empty: 'Henüz kaydettiğin bir tarif yok.',
    apply: 'Uygula',
    saveCurrent: 'Bu ayarları kaydet',
    namePlaceholder: 'Tarif adı',
    save: 'Kaydet',
    delete: 'Tarifi sil',
  },
  batch: {
    title: 'Toplu işleme',
    leaveTitle: 'Toplu işlemeden çıkılsın mı?',
    leaveBody: 'Liste temizlenecek. İndirmediğin videolar kaybolur.',
    subtitle_one: '{{count}} video seçtiğin tarifle işlenecek.',
    subtitle_other: '{{count}} video sırayla, seçtiğin tarifle işlenecek.',
    convertSubtitle_one: '{{count}} video olduğu gibi {{format}} olarak kaydedilecek.',
    convertSubtitle_other: '{{count}} video sırayla, olduğu gibi {{format}} olarak kaydedilecek.',
    convertHint: 'Hiçbir yer kesilmez, kadraj ve ses düzeyi değişmez; gizli olarak işaretlediğin yerler gizli kalır.',
    useRecipe: 'Bunun yerine tarif kullan',
    justConvert: 'Tarifsiz, sadece dönüştür',
    recipe: 'Tarif',
    videos: 'Videolar',
    start: 'Hepsini işle',
    stop: 'Durdur',
    addMore: 'Video ekle',
    clear: 'Listeyi temizle',
    downloadAll: 'Tümünü indir',
    saveToFolder: 'Tümünü klasöre kaydet',
    summary: '{{done}}/{{total}} hazır',
    remove: 'Listeden çıkar',
    status: { queued: 'Sırada', running: 'İşleniyor', done: 'Hazır', error: 'Hata', cancelled: 'Durduruldu' },
    steps: { probe: 'Okunuyor', audio: 'Ses inceleniyor', scan: 'Gizlilik taraması', screen: 'Yakınlaşma anları bulunuyor', captions: 'Altyazı', export: 'Kaydediliyor' },
  },
  export: {
    title: 'Dışa aktar',
    quality: 'Kalite',
    qualities: { small: 'Küçük dosya', balanced: 'Dengeli', high: 'Yüksek' },
    summary: {
      size: 'Boyut',
      duration: 'Süre',
      format: 'Biçim',
      estimate: 'Tahmini dosya',
    },
    checklist: {
      faces_one: '{{count}} öğe gizlenecek',
      faces_other: '{{count}} öğe gizlenecek',
      noMasks: 'Gizlenecek öğe yok',
      notSearched: 'Yüzler ve plakalar aranmadı, hiçbir şey gizlenmeyecek',
      unscanned: 'Geri getirdiğin bazı kısımlar taranmadı, oradaki yüzler görünür kalır',
      location: 'Konum bilgisi silinecek',
      metadata: 'Cihaz ve konum bilgileri temizlenecek',
      loudness: 'Ses -14 LUFS’a dengelenecek',
      silence: 'Sessiz kısımlar kesilecek',
      muted: 'Ses kapatılacak',
      denoise: 'Rüzgâr ve gürültü azaltılacak',
      captions: 'Altyazı videoya eklenecek',
      telemetry: 'Sürüş göstergesi eklenecek, rotan olmadan',
      placesBlurred: 'Gizli yerlerin çevresi bulanıklaştırılacak',
      placesCut: 'Gizli yerlerin çevresi kesilecek',
      audioUnsupported: 'Ses bu tarayıcıda işlenemiyor, video sessiz olacak',
      joined_one: '{{count}} klip uç uca birleştirilecek',
      joined_other: '{{count}} klip uç uca birleştirilecek',
      layers_one: '{{count}} katman üste eklenecek',
      layers_other: '{{count}} katman üste eklenecek',
      layerFaces: 'Üstteki videolardaki yüzler gizlenmiyor',
      speeds_one: '{{count}} kısım hızlandırılacak',
      speeds_other: '{{count}} kısım hızlandırılacak',
      transition: 'Klipler birbirine yumuşakça geçecek',
      gifSilent: 'GIF’te ses olmaz; kendi kendine döner',
      audioUnsupportedAlone: 'Ses bu tarayıcıda işlenemiyor',
    },
    saveAs: 'Ne olarak kaydedilsin',
    fileName: 'Dosya adı',
    fileType: 'Dosya türü',
    whatHappens: 'Kaydederken yapılacaklar',
    kinds: {
      video: { label: 'Video', hint: 'Paylaşmak için', start: 'Videoyu oluştur', working: 'Video oluşturuluyor', done: 'Videon hazır' },
      gif: { label: 'GIF', hint: 'Sessiz döngü', start: 'GIF oluştur', working: 'GIF oluşturuluyor', done: 'GIF’in hazır' },
      audio: { label: 'Sadece ses', hint: 'Podcast için', start: 'Sesi kaydet', working: 'Ses kaydediliyor', done: 'Sesin hazır' },
      image: { label: 'Görsel', hint: 'Kapak karesi', start: 'Görseli kaydet', working: 'Görsel kaydediliyor', done: 'Görselin hazır' },
    },
    formats: {
      mp4: 'Her yerde açılır: telefonlar, Instagram, TikTok, YouTube.',
      webm: 'Aynı görüntüde daha küçük; web siteleri ve Android için. iPhone açmayabilir.',
      mov: 'Apple uygulamaları ve Final Cut, iMovie gibi kurgu programları için.',
      gif: 'Sohbetler, belgeler ve sayfalar için. Küçük ve kısa tutulur: GIF hızla büyür.',
      m4a: 'Küçük ve net; her telefonda ve podcast uygulamalarında çalar.',
      mp3: 'Eski yeni her oynatıcıda ve uygulamada çalar.',
      wav: 'Sıkıştırılmamış, başka yerde kurgulamak için. Dosyası büyüktür.',
      jpg: 'Küçük; kapak ve küçük resimler için.',
      png: 'Kayıpsız ve keskin; daha büyük.',
    },
    qualityHints: {
      gif: 'Uzun kenar {{size}} px · saniyede {{fps}} kare',
      audio: '{{kbps}} kbps',
    },
    stillAt: 'Oynatma imlecinin olduğu {{time}} anındaki kare kaydedilir. Başka bir kare için imleci taşı.',
    limit: {
      title: 'Boyut sınırı',
      label: 'Şunun altında tut',
      unit: 'MB',
      none: 'Sınır yok',
      clear: 'Sınırı kaldır',
      hint: 'Yükleme sınırı olan e-posta ve sohbet uygulamaları için: sığan kaliteyi Shycut seçer.',
      fits: 'Yaklaşık {{size}} tutar, {{limit}} MB altında.',
      stepped: '{{limit}} MB’a sığması için görüntü {{width}}×{{height}} yapılır: tam boyutta bloklu görünürdü.',
      tooLong: 'Bu sınıra bu videonun en fazla {{length}} kadarı sığar. Videoyu kısalt ya da sınırı yükselt.',
      over: 'Dosya {{size}} oldu, {{limit}} MB sınırını aşıyor. Daha düşük bir sınır dene.',
    },
    problems: {
      gifTooLong: 'GIF kısa döngüler içindir. Bu düzenleme {{length}}, GIF ilk {{limit}} olacak.',
      noSound: 'Bu düzenlemede kaydedilecek ses yok. Videonun sesini aç ya da müzik ekle.',
    },
    onDevice: 'Bu cihazda',
    receipt: 'Cihazında yapıldı. Hiçbir şey yüklenmedi.',
    smaller: 'Orijinalinden {{percent}} küçük',
    alsoAs: 'Bir de şöyle kaydet',
    announceDone: 'Kaydetmeye hazır',
    start: 'Videoyu oluştur',
    extrasTitle: 'Bunları da kaydet',
    extrasHint: 'Aynı düzenlemeden, sırayla hazırlanır; yalnızca kare biçimi değişir. Sığdırma ya da kırpma Boyut sekmesindeki seçimi izler.',
    extras: {
      vertical: { label: 'Dikey 9:16', hint: 'Reels, TikTok, Shorts' },
      wide: { label: 'Yatay 16:9', hint: 'YouTube' },
      square: { label: 'Kare 1:1', hint: 'Akış gönderileri' },
      cover: { label: 'Kapak görseli', hint: 'Ekrandaki kare' },
    },
    mainFile: 'Ana dosya',
    startMany_one: '{{count}} dosya oluştur',
    startMany_other: '{{count}} dosya oluştur',
    batchItem: 'Dosya {{index}}/{{total}} · {{name}}',
    alsoMade: 'Bunlar da hazır',
    downloadAll: 'Hepsini indir',
    shareAll: 'Hepsini paylaş',
    downloadOne: '{{name}} indir',
    partial: 'Dosyaların hepsi oluşturulamadı: {{message}}',
    stillScanning: 'Yüzler ve plakalar hâlâ aranıyor. Bitmesini bekle; şimdi oluşturursan henüz bulunmayanlar görünür kalır.',
    working: 'Oluşturuluyor… %{{percent}}',
    eta: 'Yaklaşık {{time}} kaldı',
    preparing: 'Hazırlanıyor…',
    keepOpen: 'Bu sekmeyi açık tut. İşlem tamamen cihazında yapılıyor.',
    doneTitle: 'Videon hazır',
    doneBody: '{{size}} · {{duration}}',
    download: 'İndir',
    downloadToFiles: 'Dosyalar’a indir',
    saveToPhotos: 'Fotoğraflar’a kaydet',
    downloaded: 'İndirildi',
    downloadAgain: 'Tekrar indir',
    savedWhere: {
      ios: 'Dosyalar uygulamasında, İndirilenler klasöründe.',
      android: 'İndirilenler klasöründe. Bildirimden de açabilirsin.',
      desktop: 'İndirilenler klasöründe.',
    },
    openSaved: { ios: 'Dosyalar’ı aç', android: 'İndirilenleri aç' },
    downloadSrt: 'Altyazı dosyası (SRT)',
    share: 'Paylaş',
    again: 'Ayarları değiştir',
    sourceLost: {
      title: 'Videoya artık ulaşılamıyor',
      body: 'Açtıktan sonra değişmiş ya da taşınmış olabilir; galeri ya da bulut eşitlemesi bunu yapabilir. Aynı videoyu yeniden seç, düzenlemelerin korunur.',
      pick: 'Videoyu yeniden seç',
      checking: 'Video kontrol ediliyor…',
      different: 'Bu başka bir video gibi görünüyor. Düzenlediğin videoyu seç.',
    },
    errors: {
      failed: 'Video oluşturulamadı: {{message}}',
      noEncoder: 'Tarayıcın bu boyutta video kodlayamıyor. Daha düşük bir çözünürlük seç.',
      empty: 'Dışa aktarılacak bir bölüm kalmadı.',
      storage: 'Cihazda yeterli yer yok.',
      stalled: 'İşlem ilerlemeyi durdurdu. Tekrar dene; yine olursa daha düşük bir kalite seç.',
    },
  },
  record: {
    modesLabel: 'Ne kaydedilsin',
    modes: { screen: 'Ekran', 'screen-camera': 'Ekran + kamera', camera: 'Kamera' },
    sources: 'Ses ve kamera',
    microphone: 'Mikrofon',
    camera: 'Kamera',
    systemAudio: 'Sekme ve sistem sesi',
    systemAudioHint: 'Sonraki adımda “Sesi paylaş” kutusunu işaretle',
    defaultDevice: 'Varsayılan',
    chooseMicrophone: 'Mikrofon seç',
    chooseCamera: 'Kamera seç',
    micLevel: 'Mikrofon seviyesi',
    start: 'Kaydı başlat',
    choosing: 'Paylaşılacak alanı seç…',
    trust: '{{size}} yüklendi. Kayıt bu cihazda yapılır.',
    micSilent: 'Mikrofonun sessiz görünüyor. Kapalı olmadığından emin ol ya da başka birini seç.',
    storageLow: 'Bu cihazda yaklaşık {{minutes}} dakikalık yer kaldı.',
    screenUnavailable: 'Ekran kaydı için bilgisayar tarayıcısı gerekir. Kendini yine de çekebilirsin.',
    cameraPreview: 'Kameran',
    microphoneProblem: {
      denied: 'Mikrofon erişimi engellendi. Adres çubuğundaki simgeden izin ver.',
      'not-found': 'Mikrofon bulunamadı.',
      'in-use': 'Mikrofonu başka bir uygulama kullanıyor.',
      other: 'Mikrofon açılamadı.',
    },
    cameraProblem: {
      denied: 'Kamera erişimi engellendi. Adres çubuğundaki simgeden izin ver.',
      'not-found': 'Kamera bulunamadı.',
      'in-use': 'Kamerayı başka bir uygulama kullanıyor.',
      other: 'Kamera açılamadı.',
    },
    problems: {
      systemDenied: 'Bilgisayarın ekran kaydını engelledi. Mac’te Sistem Ayarları → Gizlilik ve Güvenlik → Ekran Kaydı bölümünden tarayıcına izin ver, sonra tekrar dene.',
      screenUnsupported: 'Bu tarayıcı ekranı kaydedemiyor. Bilgisayarda Chrome, Edge veya Firefox kullan.',
      screenFailed: 'Ekran paylaşılamadı. Tekrar dene.',
      noEncoder: 'Bu tarayıcı bu boyutta video kodlayamıyor. Tüm ekran yerine bir pencere paylaşmayı dene.',
      storageFull: 'Kayıt için bu cihazda yeterli boş alan yok.',
      prepareFailed: 'Kayıt hazırlanamadı. Bu cihazda saklanıyor; bu sayfadan yeniden açabilirsin.',
      unknown: 'Beklenmedik bir sorun yüzünden kayıt durdu.',
    },
    live: 'Kaydediliyor',
    retake: 'Tekrar çek',
    retakeCountdown: '{{take}}. çekim başlıyor',
    keepTake: 'Bu çekimi tut',
    takeLabel: '{{take}}. çekim',
    notes: 'Konuşma notları',
    notesHint: 'Kayıt sırasında oku',
    notesLines_one: '{{count}} satır, kayıtta kayar',
    notesLines_other: '{{count}} satır, kayıtta kayar',
    notesPlaceholder: 'Söylemek istediklerin, madde madde. Kayıt sırasında kendiliğinden kayar, duraklatınca durur.',
    notesSpeed: 'Kayma hızı',
    notesSpeeds: { slow: 'Yavaş', normal: 'Normal', fast: 'Hızlı' },
    notesShareHint: 'Notların videoya girmesin diye tüm ekran yerine bir pencere ya da sekme paylaş.',
    starting: 'Başlıyor…',
    savingShort: 'Saklanıyor…',
    paused: 'Duraklatıldı',
    pause: 'Duraklat',
    resume: 'Devam et',
    finish: 'Bitir',
    discard: 'Sil',
    discardTitle: 'Bu kayıt silinsin mi?',
    discardBody: 'Bu cihazdan silinecek. Bu geri alınamaz.',
    popOut: 'Kontrolleri yüzdür',
    floating: 'Kontroller diğer pencerelerinin üstünde duruyor.',
    keepTab: 'Kayıt sürerken bu sekmeyi açık tut. Boşluk duraklatır, R tekrar çeker.',
    countdown: 'Kayıt başlıyor',
    preview: 'Canlı önizleme. Kamera kayıttan sonra da taşınabilir.',
    saving: {
      user: 'Kaydın kaydediliyor…',
      'screen-ended': 'Paylaşım bitti, kayıt durdu. Kaydediliyor…',
      'storage-full': 'Cihazda yer kalmadığı için kayıt durdu. Kaydedilen kısım saklanıyor…',
      failed: 'Kayıt beklenmedik şekilde durdu. Kaydedilen kısım saklanıyor…',
    },
    savingHint: 'Hiçbir şey yüklenmiyor. Birkaç saniye sürer.',
    documentTitle: { recording: '● {{time}} Kaydediliyor', paused: 'Duraklatıldı · {{time}}' },
  },
  projects: {
    title: 'Kaldığın yerden devam et',
    meta: '{{clips}} · {{duration}} · {{when}}',
    clips_one: '{{count}} klip',
    clips_other: '{{count}} klip',
    continue: 'Devam et',
    delete: 'Projeyi sil',
    deleteTitle: 'Bu proje silinsin mi?',
    deleteBody: '“{{name}}” üzerindeki düzenlemeler bu cihazdan silinecek. Videoların kendisine dokunulmaz.',
    deleteBodyRecording: '“{{name}}” üzerindeki düzenlemeler ve ekran kaydı bu cihazdan silinecek. Bu geri alınamaz.',
    relink: {
      title: 'Dosyaları yeniden seç',
      body: 'Tarayıcı, sayfa kapanınca dosyalara erişimi bırakır. Klasörden hepsini birden seçebilirsin; hangisinin nereye ait olduğunu Shycut kendisi bulur.',
      recordingGone: 'Ekran kaydı artık bu cihazda değil. Kaydın kendisini seçersen düzenlemeler yerine oturur.',
      found: 'Bulundu',
      missing: 'Bekleniyor',
      pick_one: 'Dosyayı seç',
      pick_other: '{{count}} dosyayı seç',
      matching: 'Eşleştiriliyor…',
      open: 'Projeyi aç',
      strangers_one: '{{names}} bu projeye ait değil.',
      strangers_other: 'Bunlar bu projeye ait değil: {{names}}',
    },
  },
  transcript: {
    intro: 'Konuşmayı yazıya dökelim; sonra videoyu bir metin gibi düzenlersin. Sildiğin kelimeler videodan da kesilir. Yapay zekâ cihazında çalışır; ses hiçbir yere gönderilmez.',
    translated: 'Bu altyazılar {{language}} konuşmanın İngilizce çevirisi; kelimeleri söylenenler değil. Videoyu kelimeleriyle düzenlemek için konuşmayı söylendiği gibi yaz.',
    writeAsSpoken: '{{language}} olarak yaz',
    generate: 'Konuşmayı yazıya dök',
    hint: 'Bir kelimeye tıkla, video oradan oynasın. Kelimeleri seçip Kes’e dokun (ya da Sil tuşuna bas): o kısım videodan kesilir. Üstü çizilenleri seçip geri getirebilirsin.',
    label: 'Konuşma metni',
    fillersHint_one: 'Noktalı çizgiyle gösterilen {{count}} duraksama sesi (ııı, eee) kesilir.',
    fillersHint_other: 'Noktalı çizgiyle gösterilen {{count}} duraksama sesi (ııı, eee) kesilir.',
    idle: 'Kesmek istediğin kelimeleri seç.',
    selected_one: '{{count}} kelime · {{duration}}',
    selected_other: '{{count}} kelime · {{duration}}',
    cut: 'Kes',
    cutTitle: 'Videodan kes (Sil)',
    crutches: 'Dolgu kelimeleri',
    crutchesHint: 'Bazen anlam taşırlar, bu yüzden kendiliğinden kesilmezler. Metinde noktalı çizgiyle gösterilirler.',
    times_one: '{{count}} kez',
    times_other: '{{count}} kez',
    cutAll: 'Hepsini kes',
    restore: 'Geri getir',
  },
  recovery: {
    title: 'Bir kayıt hâlâ bu cihazda',
    unfinishedHint: 'Yarıda kalmış. Son saniyeye kadar her şey kaydedildi.',
    item: '{{date}} kaydı · {{size}}',
    open: 'Aç',
    delete: 'Sil',
    repairing: 'Onarılıyor… %{{percent}}',
    deleteTitle: 'Bu kayıt silinsin mi?',
    deleteBody: '{{item}} bu cihazdan silinecek. Bu geri alınamaz.',
  },
  chapters: {
    title: 'Bölümler',
    hint: 'Bölümler izleyicinin istediği yere atlamasını sağlar; YouTube bunları ilerleme çubuğunda gösterir.',
    make: 'Bölümleri oluştur',
    remake: 'Yeniden öner',
    none: 'Bölüm için yeterli konuşma yok ya da video bir dakikadan kısa.',
    untitled: 'Bölüm',
    titleLabel: '{{number}}. bölümün başlığı',
    remove: 'Bölümü kaldır',
    cutAway: 'Bu bölüm kesilmiş bir kısımda başlıyor.',
    tooFew: 'YouTube bölümleri en az 3 tane olduğunda gösterir.',
    tooShort: 'YouTube her bölümün en az 10 saniye olmasını ister.',
    copy: 'YouTube için kopyala',
    copied: 'Kopyalandı',
    outline: 'Özeti indir',
    outlineExplained: 'Bölüm başlıklarını ve zamanlarını bir metin dosyası (Markdown) olarak indirir; video açıklaması, blog ya da not için.',
    addHere: 'Oynatma noktasına ekle',
  },
  zoom: {
    title: 'Otomatik yakınlaşma',
    label: 'Hareketin olduğu yere yakınlaş',
    hint: 'Yazdığın ve tıkladığın yeri izler; ekranın tamamı değişince yumuşakça geri çıkar.',
    analyzing: 'Çalıştığın yerler bulunuyor… %{{percent}}',
    failed: 'Yakınlaşma için ekran incelenemedi.',
    amount: 'Güç',
    none: 'Yakınlaşmaya uygun sabit bir alan bulunamadı. Görüntü olduğu gibi kalır.',
    moments_one: '{{count}} yakınlaşma anı. Gerekmeyeni kapatabilirsin.',
    moments_other: '{{count}} yakınlaşma anı. Gerekmeyeni kapatabilirsin.',
    skip: 'Bu yakınlaşmayı kapat',
    include: 'Bu yakınlaşmayı yeniden aç',
  },
  camera: {
    layout: 'Düzen',
    layouts: {
      bubble: { label: 'Balon', hint: 'Ekranın üstünde, bir köşede' },
      split: { label: 'Bölünmüş', hint: 'Kamera ve ekran yan yana' },
      off: { label: 'Gizli', hint: 'Yalnızca ekran' },
    },
    background: 'Arka plan',
    backgrounds: { none: 'Olduğu gibi', blur: 'Bulanık', color: 'Renk', image: 'Görsel' },
    backgroundColor: 'Arka plan rengi',
    chooseImage: 'Görsel seç',
    changeImage: 'Görseli değiştir',
    imageFallback: 'Görsel seçene kadar oda bulanık görünür.',
    backgroundHint: 'Seni odadan ayırma işi bu cihazda yapılır.',
    splitSuggestion: 'Dikey videoda bölünmüş düzen seni üstte, ekranın tamamını altta gösterir.',
    useSplit: 'Bölünmüş düzeni kullan',
    place: 'Konum',
    corner: 'Köşe',
    corners: { 'top-left': 'Sol üst', 'top-right': 'Sağ üst', 'bottom-left': 'Sol alt', 'bottom-right': 'Sağ alt' },
    dragHint: 'Ya da balonu önizlemede sürükle.',
    size: 'Boyut',
    shape: 'Şekil',
    shapes: { circle: 'Daire', rounded: 'Yuvarlak kare' },
    order: 'Sıra',
    orders: { cameraTop: 'Kamera üstte', screenTop: 'Ekran üstte', cameraLeft: 'Kamera solda', screenLeft: 'Ekran solda' },
    splitHint: 'Ekranın tamamı görünür kalır, yazılar okunur.',
    offHint: 'Kamera gizli. Fikrini değiştirirsen hâlâ burada.',
  },
  media: {
    title: 'Medya',
    import: 'İçe aktar',
    addText: 'Yazı ekle',
    show: 'Medyayı göster',
    hide: 'Medyayı gizle',
    resize: 'Medya alanının genişliği (sürükle ya da ok tuşları)',
    addToEnd: 'Sona ekle',
    putOnTop: 'Üste koy',
    addHere: 'Oynatma noktasına ekle',
    remove: 'Listeden kaldır',
    inUse: 'Videoda',
    picture: 'Görsel',
    kinds: { video: 'Video', image: 'Görsel', audio: 'Ses' },
    waiting_one: '{{count}} video eklenmeyi bekliyor.',
    waiting_other: '{{count}} video eklenmeyi bekliyor.',
    addAll_one: 'Sona ekle',
    addAll_other: 'Hepsini sona ekle',
    empty: 'Başka videolar ekleyip uç uca birleştir; logo, görsel ya da müzik ekleyip üste koy. Hepsi bu cihazda kalır.',
    dragHint: 'Zaman çizelgesine sürükleyip tam istediğin yere bırakabilirsin.',
    separately: 'Bunun yerine {{count}} videoyu ayrı ayrı işle',
    separatelyTitle: 'Ayrı ayrı işlensin mi?',
    separatelyBody: 'Her video seçtiğin tarifle tek başına işlenir. Burada yaptığın düzenlemeler taşınmaz.',
    separatelyConfirm: 'Ayrı ayrı işle',
    dropEnd: 'Sona ekle',
    dropEndHint: 'Videolar şu anki videonun arkasına eklenir.',
    dropTop: 'Üste koy',
    dropTopHint: 'Oynatma noktasından başlar: logo, görsel, müzik ya da başka bir video.',
  },
  clips: {
    strip: 'Klipler',
    choose: 'Klip {{index}}: {{name}}',
    position: '{{count}} klipten {{index}}.',
    length: 'Uzunluk',
    fromVideo: 'Videodaki yeri',
    arrange: 'Düzenle',
    split: 'Böl',
    splitTooltip: 'Klibi oynatma noktasından ikiye böler. Hiçbir şey silinmez; parçaları ayrı ayrı taşıyabilir ya da çıkarabilirsin.',
    splitHint: 'Klip oynatma noktasından ikiye bölünür; parçalarını ayrı ayrı taşıyabilir ya da çıkarabilirsin.',
    splitWhere: 'Bölmek için oynatma noktasını bu klibin içine getir.',
    splitEdge: 'Oynatma noktasını klibin bölüneceği yere getir; kenarına çok yakınken bölünmez.',
    goTo: 'Klibe git',
    earlier: 'Öne al',
    later: 'Arkaya al',
    fit: 'Kadraja sığdırma',
    fits: { contain: 'Tamamı görünsün', cover: 'Kadrajı doldursun' },
    fitHint: 'Bu klibin şekli videonunkinden farklı: ya kenarlarında boşluk kalır ya da kenarlarından kırpılır.',
    followHint: 'Kesimler, altyazılar ve üstteki katmanlar bu kliple birlikte taşınır.',
    transition: 'Klipler arasında',
    transitions: { none: 'Kesme', black: 'Siyaha geçiş', white: 'Beyaza geçiş' },
    transitionLength: 'Geçiş süresi',
    seconds: '{{value}} sn',
    transitionHint: 'İki klibin birleştiği her yerde uygulanır. Ses olduğu gibi devam eder.',
    remove: 'Klibi videodan çıkar',
    onlyClip: 'Videonun tek klibi',
  },
  layers: {
    kinds: { video: 'Üstteki video', image: 'Görsel', audio: 'Müzik ya da ses', text: 'Yazı' },
    list: 'Katmanlar',
    actions: 'Katman işlemleri',
    position: '{{index}}/{{count}}',
    hide: 'Gizle',
    show: 'Göster',
    hideName: '{{name}} gizlensin',
    showName: '{{name}} gösterilsin',
    lock: 'Kilitle',
    unlock: 'Kilidi aç',
    lockName: '{{name}} kilitlensin',
    unlockName: '{{name}} kilidi açılsın',
    duplicate: 'Çoğalt',
    restack: '{{name}} yukarı ya da aşağı taşı',
    restackHint: 'Yukarı ya da aşağı sürükleyerek diğer katmanların önüne ya da arkasına al (ok tuşları da olur)',
    hiddenNotice: 'Gizli: önizlemede ve videoda yok. Yeri ve ayarları korunuyor.',
    lockedTiming: 'Kilitli: zaman çizelgesinde sürüklenemez. Bu düğmeler yine de taşır.',
    lockedFrame: 'Kilitli: önizlemede sürüklenemez, dokunuşlar altındakine geçer.',
    placement: 'Yerleşim',
    place: 'Karede yerleştir',
    anchors: {
      'top-left': 'Sol üst',
      'top-center': 'Üst',
      'top-right': 'Sağ üst',
      'middle-left': 'Sol',
      'middle-center': 'Orta',
      'middle-right': 'Sağ',
      'bottom-left': 'Sol alt',
      'bottom-center': 'Alt',
      'bottom-right': 'Sağ alt',
    },
    text: {
      title: 'Yazı',
      default: 'Yazın',
      words: 'Metin',
      placeholder: 'Buraya yaz',
      hint: 'Yeni satır için Enter.',
      look: 'Görünüm',
      looks: { plain: 'Sade, hafif gölgeli', outline: 'Kenarlı', box: 'Koyu şerit üstünde', tag: 'Renkli etiket üstünde' },
      color: 'Renk',
      colors: { ffffff: 'Beyaz', '0b0b0c': 'Siyah', c6f25e: 'Fıstık yeşili', ffe14d: 'Sarı', ff6b5e: 'Mercan', '6cb8ff': 'Gök mavisi' },
      font: 'Yazı tipi',
      fonts: { sans: 'Düz', serif: 'Tırnaklı', mono: 'Daktilo' },
      align: 'Hizalama',
      aligns: { left: 'Sola', center: 'Ortaya', right: 'Sağa' },
      bold: 'Kalın',
      dragHint: 'Önizlemede sürükleyerek yerleştir, köşesinden tutup büyüt. Yazmak için çift tıkla.',
    },
    bar: '{{kind}}: {{name}}, {{start}}–{{end}}',
    timing: 'Zamanlama',
    startHere: 'Burada başlasın',
    endHere: 'Burada bitsin',
    fromStart: 'Baştan başlasın',
    wholeVideo: 'Tüm videoda',
    timingHint: 'Zaman çizelgesinde sürükleyerek taşı, kenarından tutup uzat ya da kısalt.',
    look: 'Görünüm',
    free: 'Kutu içinde',
    fill: 'Tam ekran',
    size: 'Boyut',
    opacity: 'Opaklık',
    dragHint: 'Önizlemede sürükleyerek yerleştir, köşesinden tutup büyüt.',
    resizeHint: 'Boyutlandırmak için sürükle',
    sound: 'Ses',
    volume: 'Ses seviyesi',
    silent: 'Sessiz',
    duck: 'Biri konuşurken kısılsın',
    duckHint: 'Videoda konuşma olunca müzik yumuşakça kısılır, bitince geri gelir.',
    fade: 'Yumuşak giriş ve çıkış',
    motion: {
      title: 'Hareket',
      in: 'Girerken',
      out: 'Çıkarken',
      entrances: { none: 'Yok', fade: 'Belirme', rise: 'Yükselme', pop: 'Zıplama', typewriter: 'Daktilo', words: 'Kelime kelime' },
      exits: { none: 'Yok', fade: 'Solma', sink: 'Alçalma', pop: 'Küçülme' },
      preview: 'Oynat',
      hint: 'Önizlemede ve kaydedilen videoda aynı görünür.',
    },
    loop: 'Bitince başa sar',
    loopHint: 'Sona gelince baştan çalar, böylece daha uzun sürebilir.',
    facesNotHidden: 'Üste koyduğun videolardaki yüzler şimdilik otomatik gizlenmiyor.',
    forward: 'Öne getir',
    backward: 'Arkaya gönder',
    remove: 'Videodan kaldır',
  },
  speed: {
    title: 'Hızlandır',
    rate: 'Hız',
    start: 'Buradan hızlandır',
    finish: 'Burada bitsin',
    finishTitle: '{{start}} ile burası arasını hızlandır',
    marking: 'Hızlanmanın biteceği yere git (oynat ya da zaman çizelgesinde sürükle), sonra “Burada bitsin”e bas. Vazgeçmek için Esc.',
    hint: 'Uzun bir yürüyüş ya da sessiz bir yol gibi bir kısmı hızlandır: başına gidip “Buradan hızlandır”a bas, bitmesi gereken yerde “Burada bitsin”e bas. {{limit}} ve altında ses doğal kalır; daha hızlı kısımlar sessiz olur.',
    becomes: '{{duration}} olur',
    normal: 'Normal hız',
    clip: 'Klibin hızı',
    mixed: 'Bu klibin bazı kısımları farklı hızda. Bir hız seçersen tamamı o hızda oynar.',
  },
  timeline: {
    mute: 'Videonun sesini kapat',
    unmute: 'Videonun sesini aç',
    fit: 'Sığdır',
    fitHint: 'Videonun tamamını göster',
    zoomIn: 'Yakınlaştır',
    zoomOut: 'Uzaklaştır',
  },
  selection: {
    label: 'Seçili öğe',
    close: 'Seçimi kapat',
  },
  shortcuts: {
    title: 'Klavye kısayolları',
    lead: 'Bunu tekrar görmek için düzenleyicide ? tuşuna bas.',
    keys: { space: 'Boşluk', delete: 'Sil' },
    groups: { playback: 'Oynatma', editing: 'Düzenleme', layers: 'Katmanlar', view: 'Zaman çizelgesi' },
    actions: {
      play: 'Oynat ya da durdur',
      seek: 'Bir saniye geri ya da ileri',
      seekFar: '5 saniye geri ya da ileri',
      frame: 'Bir kare geri ya da ileri',
      trimIn: 'Video burada başlasın',
      trimOut: 'Video burada bitsin',
      cut: 'Çıkarılacak kısmı işaretle, sonra çıkar',
      split: 'Klibi imleçte böl',
      remove: 'Seçileni kaldır',
      undo: 'Geri al',
      redo: 'Yinele',
      deselect: 'İşareti ya da seçimi bırak',
      addText: 'İmleçte yazı ekle',
      duplicate: 'Seçili katmanı çoğalt',
      forward: 'Öne getir',
      backward: 'Arkaya gönder',
      hide: 'Gizle ya da göster',
      lock: 'Kilitle ya da kilidi aç',
      nudge: 'Zaman çizelgesinde kaydır',
      free: 'Serbest yerleştirmek için sürüklerken basılı tut',
      zoomIn: 'Zaman çizelgesini yakınlaştır',
      zoomOut: 'Zaman çizelgesini uzaklaştır',
      zoomFit: 'Videonun tamamını sığdır',
      guide: 'Bu kısayolları göster',
    },
  },
} as const;

type Widen<T> = { -readonly [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Translation = Widen<typeof tr>;

export default tr as Translation;
